(function () {
	let swiperMulticolumn;
	const multicolumnSwipeEnabled = document.querySelector(
		".swiper--multicolumn"
	);

	const initSlider = () => {
		// The resize observer fires on every size change (e.g. the mobile address bar showing/hiding);
		// only build the slider once.
		if (swiperMulticolumn) return;
		multicolumnSwipeEnabled.classList.add("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		slides.forEach((slide) => {
			slide.classList.add("swiper-slide");
		});

		swiperMulticolumn = new Swiper(".swiper--multicolumn", {
			loop: false,
			// Cards side by side on phones (section setting, default 1); arrows/swipes move one card at a time.
			slidesPerView: Number(multicolumnSwipeEnabled.dataset.mobilePerView) || 1,
			slidesPerGroup: 1,
			speed: 400,
			watchOverflow: true,
			grabCursor: true,
			navigation: {
				nextEl: ".multicolumn-button-next",
				prevEl: ".multicolumn-button-prev",
			},
			on: {
				init: updateProgress,
				progress: updateProgress,
				resize: updateProgress,
			},
		});
	};

	// Optional scroll progress bar between the arrows (section setting "Show scroll progress bar on mobile").
	function updateProgress(swiper) {
		const thumb = multicolumnSwipeEnabled.querySelector("[data-multicolumn-progress]");
		if (!thumb || !swiper || !swiper.slides || !swiper.slides.length) return;
		const perView = Number(swiper.params.slidesPerView) || 1;
		const visible = Math.min(1, perView / swiper.slides.length);
		const progress = Math.min(1, Math.max(0, swiper.progress || 0));
		thumb.style.width = `${visible * 100}%`;
		thumb.style.left = `${progress * (1 - visible) * 100}%`;
	}

	const destroySlider = () => {
		if (!swiperMulticolumn) return;
		multicolumnSwipeEnabled.classList.remove("multicolumn-swiper-wrapper");
		const slides = document.querySelectorAll(".multicolumn-list__item");

		swiperMulticolumn.destroy(true, true);
		swiperMulticolumn = undefined;

		slides.forEach((slide) => {
			slide.removeAttribute("style");
			slide.classList.remove("swiper-slide");
		});
	};

	const initMulticolumn = () => {
		const multicolumnSection = document.querySelector(".multicolumn-section");

		const sectionResizeObserver = new ResizeObserver((entries) => {
			const [entry] = entries;

			if (entry.contentRect.width < 576 && multicolumnSwipeEnabled) {
				initSlider();
			} else if (swiperMulticolumn) {
				destroySlider();
			}
		});

		sectionResizeObserver.observe(multicolumnSection);
	};

	if (swiperMulticolumn) {
		destroySlider();
	}
	initMulticolumn();
	document.addEventListener("shopify:section:load", function () {
		if (swiperMulticolumn) {
			destroySlider();
		}
		initMulticolumn();
	});
})();
